import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  constrained?: boolean;
}
export function SectionWrapper({
  children,
  className = '',
  id,
  constrained = true
}: SectionWrapperProps) {
  return <section id={id} className={`py-16 md:py-24 ${className}`} data-id="element-283">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className={`mx-auto px-6 ${constrained ? 'max-w-3xl' : 'max-w-5xl'}`} data-id="element-284">
        {children}
      </motion.div>
    </section>;
}